import React from 'react';
import Search from 'layouts/header/search/search';
import Container from 'atomic/container';
import Navigation from 'layouts/header/navigation/navigation';
import CategoryList from 'layouts/header/category-list/category-list';
import CategoryListOverlay from 'layouts/header/category-list-overlay/category-list-overlay';
import useToggle from 'hooks/use-toggle';

import { useSelector } from '@ecommerce/nest-ssr/common';
import { CategorySimple } from 'modules/shared/modules/categories-shared/interfaces/category-simple.interface';

import './header.desktop.scss';

export const HeaderDesktop: React.FC = () => {
    const [isOpenMenu, menuState] = useToggle();
    const departments = useSelector((state: { departments: CategorySimple[]; }) => state.departments ?? []);

    return (
        <>
            <header className="header">
                <Container>
                    <div className="header__partial">
                        <Navigation onToggle={menuState.toggle} isOpen={isOpenMenu}/>
                        <Search/>
                    </div>
                    <CategoryList onClose={menuState.toggle} isOpenMenu={isOpenMenu} departments={departments}/>
                </Container>
            </header>
            {isOpenMenu && <CategoryListOverlay onClose={menuState.toggle}/>}
        </>
    );
};

export default HeaderDesktop;
